import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { FiltersTypography } from "@pages/Catalog/components/components";
import Filters from "@pages/Catalog/components/Filters/Filters";

import { useFiltersData } from "@hooks/useFiltersData";

import GradientDialog from "@components/Dialog";
import Loadable from "@layouts/Loadable";

interface IDialog {
  open: boolean;
  handleClose: () => void;
  handleSetFilters: (item: string[]) => void;
}

const Dialog: FC<IDialog> = ({ open, handleClose, handleSetFilters }) => {
  const { t } = useTranslation("catalogue");

  const { initialValues, uniqueTags, availableTags, dataFilters, maxBpm, maxLength, handleSubmit, isLoading } =
    useFiltersData(handleSetFilters);

  const [button, setButton] = useState<JSX.Element>(null);

  return (
    <GradientDialog
      open={open}
      handleClose={handleClose}
      btn={button}
      sx={{
        "&&": {
          ".MuiDialog-paper > div > div:last-child": {
            paddingBottom: "0",
          },
          ".dialog-button": {
            padding: "10px 24px 24px 24px",
          },
        },
      }}
    >
      <FiltersTypography marginBottom="24px">{t("filtersTitle")}</FiltersTypography>
      <Loadable isLoading={isLoading}>
        <Filters
          maxLength={maxLength}
          maxBpm={maxBpm}
          handleSubmitForm={handleSubmit}
          initialFiltersValues={initialValues}
          uniqueTags={uniqueTags}
          availableTags={availableTags}
          dataFilters={dataFilters}
          handleClose={handleClose}
          setButton={setButton}
        />
      </Loadable>
    </GradientDialog>
  );
};

export default Dialog;
